import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import report from './modules/report'
import booking from './modules/booking'
import category from './modules/category'
import tool from './modules/tool'
import notification from './modules/notification'
import versionControl from './modules/version-control'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    booking,
    report,
    user,
    category,
    tool,
    notification,
    versionControl,
  },
  state: {
    controls: {
      showDrawer: true,
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    },
  },
})
